/**
 * Helper function for building form prefix strings
 * you can call .get on the result again and again
 * those strings will be concatenated
 * the magic is that you will get autocompletion according to the Interface you pass in each step,
 * which you would not have otherwise
 *
 * USAGE:
 *         autocompleteType<Interface>().get('key').toString()
 *         resulting in: 'key'
 *
 *         or
 *
 *         autocompleteType<Interface>().get('key').get('subkey').toString()
 *         resulting in: 'key.subkey'
 *
 *         or
 *
 *         autocompleteType<Interface>('prefix').get('key').get('subkey').toString()
 *         resulting in: 'prefix.key.subkey'
 *
 * NOTE: you can omit .toString() most of the time because it will be called implicitly
 * when the object is casted to a string
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- object value could be anything
export function autocompleteType<T extends Record<string, any>>(prefix?: string) {
  return {
    get: <K extends keyof T>(key: K) => {
      return autocompleteType<Required<T>[K]>(
        `${prefix ? `${prefix}.` : ''}${key}`,
      )
    },
    toString: () => `${prefix || ''}`,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- object value could be anything - value is not used
export function useAutocompleteName<T extends Record<string, any>>(prefix?: string) {
  return (name: keyof T) => `${prefix ? `${prefix}.` : ''}${name}`
}

// ac = autocomplete - short, shallow, simple
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- object value could be anything - value is not used
export function ac<T extends Record<string, any>>(name: keyof T) {
  return `${name}`
}
